/**
 * Smoothed weight trend: exponential moving average over the first weigh-in
 * of each day. alpha 0.1 ≈ a 10-day smoothing window, which damps day-to-day
 * water swings while still following real change within a couple of weeks.
 */
export interface DayWeight { day: string; weight: number; measuredAt?: string }

export function emaTrend(points: ReadonlyArray<DayWeight>, alpha: number = 0.1): Array<{ day: string; y: number }> {
  const firstPerDay = new Map<string, number>();
  const ordered: DayWeight[] = [...points].sort((a, b) => (a.measuredAt ?? a.day).localeCompare(b.measuredAt ?? b.day));
  for (const p of ordered) if (!firstPerDay.has(p.day)) firstPerDay.set(p.day, p.weight);
  const out: Array<{ day: string; y: number }> = [];
  let ema: number | null = null;
  for (const [day, w] of [...firstPerDay.entries()].sort((a, b) => a[0].localeCompare(b[0]))) {
    ema = ema === null ? w : ema + alpha * (w - ema);
    out.push({ day, y: ema });
  }
  return out;
}
